import { createSelector } from 'reselect'

const loadingSchedulerSelector = (state) => state.loadingScheduler.slots

const notCompletedSlots = createSelector(loadingSchedulerSelector, (slots) =>
    slots.filter((slot) => slot.parcelsLoaded !== slot.totalParcels),
)

export default notCompletedSlots
